
import { HttpTimePredictionList,HttpAddressList,HttpDeleteTimePrediction} from '@/service/logistics';
import TableList from "@components/templates/tablelist";

import comIndex from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin';

export default {
    mixins: [TableList, mixin],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            addressCodeList:[],
            formData: {
                search: {
                    EQ_type: "ocean",
                },
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            title:"",
            enTitle:"",
            Plugins: { show: true },
        };
    },
    created() {
        this.getAddress();
        
      },
    methods: {
        ajaxRequest: HttpTimePredictionList,
        interceptRequest(params) {
            if(!params.search.EQ_type){
                params.search.EQ_type = "ocean"
                this.$set(this.formData.search,"EQ_type","ocean");
            }
            return params
        },
    
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
                if(this.isOcean){
                    this.enTitle = 'fbb.logistics.time_add_ocean'
                    this.title = "添加海运时间"
                }else if(this.isPort){
                    this.enTitle = 'fbb.logistics.time_add_port'
                    this.title = "添加港口至仓库时间"
                }else if(this.isPallet){
                    this.enTitle = 'fbb.logistics.time_add_pallet'
                    this.title = "添加托盘包装及贴标时间"
                }else if(this.isAmazon){
                    this.enTitle = 'fbb.logistics.time_add_amazon'
                    this.title = "添加亚马逊送仓等待时间"
                }else if(this.isSailWait){
                    this.enTitle = 'fbb.logistics.time_add_sail'
                    this.title = "添加发船等待时间"
                }
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t(this.enTitle, { defaultValue: this.title }),
                        show:true,
                        width:400,
                        component: "comIndex",
                        timeType:this.formData.search.EQ_type,
                        type:'add',
                        showFooter:false,
                    }
                    break;              
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show:true,
                        width:400,
                        component: "comIndex",
                        activeid:params,
                        timeType:this.formData.search.EQ_type,
                        type:'edit',
                        showFooter:false,
                    }
                    break;
                case 'delete':
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        desc: this.$t('fbb.localemanage.confirm_delete',{defaultValue:'删除后不可恢复，是否确认删除？'}),
                        ajaxRequest: HttpDeleteTimePrediction
                    };
                    break;
                case "upload":
                this.operate = {
                    show: true,
                    title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
                    width: 460,
                    showFooter: false,
                    action: process.env.VUE_APP_APIURL_FBB + "/api/v2/timePrediction/batchImport",
                    name: "multipartFile",
                    component: "compUpload",
                    data: {
                        type:this.formData.search.EQ_type,
                         contextId: global.SYSID 
                      },
                    download: () => {
                        let template;
                        if(this.formData.search.EQ_type === 'ocean'){
                            template = "/static/template/logistics_ocean.xls"
                        }else if(this.formData.search.EQ_type === 'port'){
                            template = "/static/template/logistics_port.xls"
                        }else if(this.formData.search.EQ_type === 'pallet'){
                            template = "/static/template/logistics_pallet.xls"
                        }else if(this.formData.search.EQ_type === 'amazon'){
                            template = "/static/template/logistics_amazon.xls"
                        }else if(this.formData.search.EQ_type === 'sail_wait'){
                            template = "/static/template/logistics_sailWait.xls"
                        }
                        this.handleWebfs(template, {}, {
                            executor: 'download',
                            type: 'url'
                        });
                    }
                };
                break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show:true,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.delete', { defaultValue: '删除' }),
                show:true,
                params: id,
                operate: 'delete'
            }
          ]
        },
        getAddress(){
            HttpAddressList({
                'search[EQ_warehouseType]':2,
                rows: 1000,
            }).then(res=>{
                this.addressCodeList = res.data.content.map(item => {
            return {
                label: item.code,
                value: item.id
            } })
            },err=>{
                this.$VMessage.error(err.message);
            })
          },
    },
    computed: {
        ...mapGetters('dictionary', ['getSystemPortList',"getCompanyList","getFBBFilterDisabledAllWarehouse"]),
        isOcean() {
			return this.formData.search.EQ_type === 'ocean'
		},
        isPort() {
			return this.formData.search.EQ_type === 'port'
		},
        isPallet() {
			return this.formData.search.EQ_type === 'pallet'
		},
        isAmazon() {
			return this.formData.search.EQ_type === 'amazon'
		},
        isSailWait() {
			return this.formData.search.EQ_type === 'sail_wait'
		},
        TabsData() {
            return [
                {
                    name: this.$t('fbb.logistics.time_ocean', { defaultValue: "海运时间" }),
                    key: 'EQ_type',
                    val: 'ocean',
                },
                {
                    name: this.$t('fbb.logistics.time_port', { defaultValue: "港口至仓库时间" }),
                    key: 'EQ_type',
                    val: "port",
                },
                {
                    name: this.$t('fbb.logistics.time_pallet', { defaultValue: "托盘包装及预约时间" }),
                    key: "EQ_type",
                    val: "pallet",
                },
                {
                    name: this.$t('fbb.logistics.time_amazon', { defaultValue: "亚马逊送仓等待时间" }),
                    key: "EQ_type",
                    val: "amazon",
                },{
                    name: this.$t('fbb.logistics.time_sail', { defaultValue: "发船等待时间" }),
                    key: "EQ_type",
                    val: "sail_wait",
                },
            ]
        },
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: "添加" }),
                operate: "add",
                theme: "primary",
            }, {
                name: this.$t('fbb.alloment.muti_import', { defaultValue: "批量导入" }),
                operate: "upload",
            }]
        },
        SearchsData() {
            return [{
                    label: this.$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司' }),
                    key: 'EQ_carrierId',
                    tag: 'vSelect',
                    show: true,
                    options: this.getCompanyList,
                    props: {
                        filterable: true,
                    },
                },{
                    label: this.$t('fbb.logistics.cost_time', { defaultValue: '时间(天)' }),
                    key: 'EQ_timeQuantity',
                    show: true,
                    tag: 'vInputNumber',
                }/* ,{
                    label: this.$t('', { defaultValue: '发运港口' }),
                    key: 'EQ_shipPortId',
                    show: this.isOcean||this.isSailWait,
                    tag: 'vSelect',
                    options:this.getSystemPortList ,
                    props: {
                        filterable: true,
                    },
                },{
                    label: this.$t('', { defaultValue: '目的港' }),
                    key: 'EQ_purposePortId',
                    show: this.isOcean,
                    tag: 'vSelect',
                    options:this.getSystemPortList ,
                    props: {
                        filterable: true,
                    },
                },{
                    label: this.$t('', { defaultValue: '港口' }),
                    key: 'EQ_purposePortId',
                    show: this.isPort,
                    tag: 'vSelect',
                    options:this.getSystemPortList ,
                    props: {
                        filterable: true,
                    },
                },{
                    label: this.$t('', { defaultValue: '仓库' }),
                    key: 'EQ_depotId',
                    show: this.isPort||this.isPallet,
                    tag: 'vSelect',
                    options:this.getFBBFilterDisabledAllWarehouse ,
                    props: {
                        filterable: true,
                    },
                },{
                    label: this.$t('', { defaultValue: '亚马逊门店' }),
                    key: 'EQ_depotId',
                    show: this.isPort,
                    tag: 'vSelect',
                    options:this.addressCodeList ,
                    props: {
                        filterable: true,
                    },
                },{
                    label: this.$t('', { defaultValue: '亚马逊仓' }),
                    key: 'EQ_amazonId',
                    show: this.isAmazon,
                    tag: 'vSelect',
                    options:this.addressCodeList ,
                    props: {
                        filterable: true,
                    },
                }, */
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 90,
                    render: this.getOperateNodes
                },{
                    title: this.$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司	' }),
                    key: 'carrierId',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getCompanyList, row.carrierId)
                }, {
                    title: this.$t('fbb.headlogistics.ship_port', { defaultValue: '发运港口' }),
                    width:this.isOcean||this.isSailWait? 300 : 0,
                    key: 'shipPort',
                }, {
                    title: this.$t('fbb.headlogistics.purpose_port', { defaultValue: '目的港' }),
                    width:this.isOcean? 300 : 0,
                    key: 'purposePort',
                }, {
                    title: this.$t('fbb.logistics.cost_port', { defaultValue: '港口' }),
                    width:this.isPort? 300 : 0,
                    key: 'purposePort',
                }, {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    width:this.isPort||this.isPallet? 300 : 0,
                    key: 'purposeDepot',
                }, {
                    title: this.$t('fbb.inbound.amazon_warehouse', { defaultValue: '亚马逊仓' }),
                    width:this.isAmazon? 300 : 0,
                    key: 'amazonFc',
                }, {
                    title: this.$t('fbb.logistics.cost_time', { defaultValue: '时间(天)' }),
                    maxWidth: 200,
                    key: 'timeQuantity',
                }];
        },
    },
};




